import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { hoyMX } from "@/lib/factoraje";

// Build G: «hoy» de la pantalla de pagos en hora de México (America/Mexico_City), no en UTC.
export { hoyMX };

// Build G: cargos por pago tardío (y en abono a capital, moratorios diferidos) que se revertirían
// al registrar un pago con FECHA ANTERIOR. null mientras carga; {} con fecha de hoy o sin nada que revertir.
export function useReversionFechaAnterior(creditoId, fechaPago, { tipo = "pago", integranteId = "", activo = true } = {}) {
  const [rev, setRev] = useState({});
  useEffect(() => {
    if (!activo || !creditoId || !fechaPago || fechaPago >= hoyMX()) { setRev({}); return undefined; }
    let vivo = true;
    setRev(null);
    api.get(`/creditos/${creditoId}/reversion-fecha-anterior`, {
      params: { fecha_pago: fechaPago, tipo, integrante_cliente_id: integranteId || undefined },
    }).then((r) => vivo && setRev(r.data || {})).catch(() => vivo && setRev({}));
    return () => { vivo = false; };
  }, [creditoId, fechaPago, tipo, integranteId, activo]);
  return rev;
}

// Crédito con los cargos que se revertirán ya fuera (para el sugerido y el desglose).
export const creditoSinRevertibles = (cred, rev) =>
  (cred && rev?.credito_ajustado ? { ...cred, ...rev.credito_ajustado } : cred);
